// extracted by mini-css-extract-plugin
export default {"logout":"Logout_logout__Z1Z5k"};